import Model from './Model'

export default class PageSection extends Model {
    resource() {
        return 'pages/sections'
    }
}
